function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea52f"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea52f"] = parcelRequire;
}
parcelRequire.register("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ef7689007096c8a0$export$f7ad0328861e2f03; }, function (v) { return $ef7689007096c8a0$export$f7ad0328861e2f03 = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = {};
function $ef7689007096c8a0$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$ef7689007096c8a0$var$mapping[keys[i]] = pairs[keys[i]];
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $3ec2e15695a1d6ed$exports = {};

(parcelRequire("kyEFX")).register(JSON.parse('{"5ZPII":"index.a784cef8.js","ala1R":"sad_emoji.4bafc11e.png","3SC1H":"meh_emoji.0be44f8f.png","b2U93":"good_emoji.73c6c581.png","hQz39":"awesome_emoji.ce5de324.png","l5COZ":"lovedit_emoji.99bd79bb.png","dCjy4":"red_star_2.6c68f98f.png","9CD6G":"grey-star.d58198fb.png","8yIvx":"web-vitals.7cc2ca79.js","12Neq":"index.0d66bea4.css"}'));


//# sourceMappingURL=index.3766f1f8.js.map
